function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13 16C15.1875 16 17 14.2187 17 12C17 9.8125 15.1875 8 13 8C10.7812 8 9 9.8125 9 12C9 14.2187 10.7812 16 13 16ZM15.7812 17H15.25C14.5625 17.3437 13.8125 17.5 13 17.5C12.1875 17.5 11.4062 17.3437 10.7187 17H10.1875C7.875 17 6 18.9062 6 21.2187V22.5C6 23.3437 6.65625 24 7.5 24H18.5C19.3125 24 20 23.3437 20 22.5V21.2187C20 18.9062 18.0937 17 15.7812 17Z",
  fill: "#8B90A0"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M20.6919 14.7468C20.0504 14.7468 19.778 14.1053 20.2086 13.622L22.3001 11.2406C22.5901 10.9154 22.9855 10.9242 23.2667 11.2406L25.3757 13.622C25.7887 14.079 25.5515 14.7468 24.8836 14.7468H23.4864V18.3146C23.4864 18.7012 23.1788 19 22.801 19C22.4055 19 22.1067 18.7012 22.1067 18.3146V14.7468H20.6919Z",
  fill: "#8B90A0"
});

var SvgPickup = function SvgPickup(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPickup, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pickup.c2a1bec9.svg";
export { ForwardRef as ReactComponent };